<template>
  <div
    v-if="items"
    class="ws-checkbox-list"
  >
    <div class="flex-md">
      <div
        v-for="(column, i) of itemsFilteredSplitedColumns"
        :key="`itemsColumn-${i}`"
        :class="
          `ws-checkbox-col col q-col-gutter-md col-equal col-${12 / columns}`
        "
      >
        <div
          v-for="(item, index) in column"
          :key="get(item, uidProp, JSON.stringify(item)) + '_item_' + index"
          class="ws-checkbox-item"
          :class="{ disabled: get(item, 'disable') }"
        >
          <ws-checkbox
            v-model="valueData[item[uidProp]]"
            large
            full-width
            class="ws-hover-fly-in-trigger"
            :class="{
              selected: valueData[item[uidProp]] === true || showSelectedOnly,
            }"
            :disable="get(item, 'disable') || !inEdit"
            @input="$emit('input', { ...valueData })"
          >
            <slot
              :item="item"
              :is-selected="valueData[item[uidProp]] === true || showSelectedOnly"
            ></slot>
          </ws-checkbox>
          <div class="info">
            <slot
              name="info"
              :item="item"
              :is-selected="valueData[item[uidProp]] === true || showSelectedOnly"
            ></slot>
          </div>
        </div>
      </div>
    </div>
    <slot name="extra"></slot>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue';
import {WsCheckbox} from './WsCheckbox.vue';

export default defineComponent( {
  name: 'WsCheckboxList',
  components: {
    WsCheckbox,
  },
  props: {
    value: { type: undefined, default: undefined },
    items: {
      type: Array,
      default: () => [],
    },
    uidProp: {
      type: String,
      default: 'id',
    },
    showSelectedOnly: {
      type: Boolean
    },
    inEdit: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Number,
      default: 1, // expected one of 1,2,3,4,6,12
    }
  },
  setup(props) {
    const valueData = ref(props.value);

    watch(
      () => props.value,
      (newValue) => {
        valueData.value = newValue;
      }
    );

    const itemsFiltered = computed(() => {
      return props.showSelectedOnly
        ? props.items.filter((item: Array<string>): boolean => {
          return valueData?.[item[props.uidProp]] === true;
        })
        : props.items;
    });

    const itemsFilteredSplitedColumns = computed( () => {
      if (!props.columns) {
        return [itemsFiltered];
      }

      const items = itemsFiltered.value;
      const limit = Math.ceil(items.length / props.columns);
      const resultItems: any[][] = [];
      let chunk: any[] = [];

      items.forEach((item: any, index: number) => {
        if (index && index % limit === 0) {
          resultItems.push(chunk);
          chunk = [];
        }
        chunk.push(item);
      });
      resultItems.push(chunk);

      return resultItems;
    });

    return { props, valueData, itemsFilteredSplitedColumns };
  }

});
</script>

<style lang="scss" scoped>
.info {
  margin-left: 28px;
}

.ws-checkbox-item + .ws-checkbox-item {
  margin-top: map-get($space-md, y);
}

.ws-checkbox {
  ::v-deep {
    .q-checkbox__label {
      .secondary {
        color: $ws-base080;
        font-weight: normal;
      }
    }
  }

  &.selected {
    font-weight: bold;
  }
}
</style>
